
import { v4 as uuidv4 } from "uuid";
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace objUtil {
  export const isStrNullOrUndefined = (data?: string | null | undefined) => {
    return data === null || data === undefined || data?.trim()?.length === 0 || data?.trim() === '';
  }

  export const isNullOrEmpty = isStrNullOrUndefined;

  export const isObjNullOrUndefined = (data?: object | null | undefined): boolean => {
    return data === null || data === undefined;
  }
  export const isNumNullOrUndefined = (data?: number | null | undefined): boolean => {
    return data === null || data === undefined;
  }

  export const uuidStr = (): string => {
    return uuidv4();
  }

}


